//
//
//
//
//
//
//
//
//

export default {
  name: "App",
  created() {
    //默认接口路径
    this.$http.defaults.baseURL =
      "http://app.jinkaodian.com/CL.ExamWebService/";

    /*
    //解决安卓端微信页面长按时出现浏览器选择打开问题
    document.oncontextmenu = function(e) {
      //或者return false;
      e.preventDefault();
    };
    */
  }
};



// WEBPACK FOOTER //
// ./src/App.vue